export default __webpack_public_path__ + "images/Tapclicks.f7df92cbe3c4d9c9a2c03faca4afe4d3.svg";